<div class="color-swatch-picker">
  @if (allowTransparent) {
    <button
      type="button"
      class="color-swatch-picker__item color-swatch-picker__item--transparent"
      [class.color-swatch-picker__item--selected]="isTransparentSelected"
      [style.--swatch-ring-color]="selectedRingColor"
      (click)="selectTransparent()"
      title="Transparent"
    ></button>
  }
  @for (c of colors; track c) {
    <button
      type="button"
      class="color-swatch-picker__item"
      [style.background-color]="c"
      [style.--swatch-ring-color]="ringColorFor(c)"
      [class.color-swatch-picker__item--selected]="isPresetSelected(c)"
      (click)="selectPreset(c)"
    ></button>
  }
  @if (allowCustom) {
    <div
      class="color-swatch-picker__item color-swatch-picker__item--picker"
      [class.color-swatch-picker__item--selected]="isCustomSelected"
      [style.--swatch-ring-color]="selectedRingColor"
      title="Custom color"
    >
      <icn-color-picker
        [value]="pickerDisplayValue"
        (valueChange)="onCustomColorChange($event)"
      ></icn-color-picker>
    </div>
  }
</div>
